<div class="quote-subtotal__label" [class.quote-subtotal__label--discount]="isDiscount">
  {{ totalLabel }}
  <lx-time-left
    *ngIf="isDiscount"
    [quoteKey]="quoteKey"
    [expirationDate]="closestExpirationDate"
    [activeQuoteSlot]="activeQuoteSlot"
    [isAccordionExpanded]="isAccordionExpanded"
    [quoteOutputsExpirationDates]="quoteOutputsExpirationDates"
  ></lx-time-left>
</div>
<div class="quote-subtotal__price" [class.quote-subtotal__price--discount]="isDiscount">
  {{ amountTotal | lxPrice : { currency: currency, minDecimalPlaces: decimalPlaces, multiplier: isDiscount ? -1 : 1 } }}
</div>
<lx-quote-accordion-item
  [totalItems]="totalItems"
  [isAccordionExpanded]="isAccordionExpanded"
  [roundedElements]="roundedElements"
  (expandAccordion)="expandAccordion.emit()"
></lx-quote-accordion-item>
